import React from "react";
import { Routes as RouterRoutes, Route } from "react-router-dom";
// Add your imports here
import ProfileSelectionLanding from "./pages/profile-selection-landing";
import PaymentProcessing from "./pages/payment-processing";
import DocumentUploadManagement from "./pages/document-upload-management";
import RegistrationSuccessConfirmation from "./pages/registration-success-confirmation";
import MultiStepRegistrationForm from "./pages/multi-step-registration-form";
import NotFound from "./pages/NotFound";

const Routes = () => {
  return (
    <RouterRoutes>
      {/* Define your routes here */}
      <Route path="/" element={<ProfileSelectionLanding />} />
      <Route path="/profile-selection-landing" element={<ProfileSelectionLanding />} />
      <Route path="/payment-processing" element={<PaymentProcessing />} />
      <Route path="/document-upload-management" element={<DocumentUploadManagement />} />
      <Route path="/registration-success-confirmation" element={<RegistrationSuccessConfirmation />} />
      <Route path="/multi-step-registration-form" element={<MultiStepRegistrationForm />} />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
};

export default Routes;